export default {
  navbar: {
    home: "Home",
    roles: "Roles",
    features: "Features",
    whyUs: "Why Us",
    contactUs: "Contact Us",
  },
  home: {
    TeachWings: "TeachWings",
    comprehensive: "Comprehensive",
    modules: "Modules",
    for: "for",
    schoolManagement: "School Management App",
    customized: "Customized",
    userAcees: "User Access",
    heading_01: "Fly Higher with",
    how: "How",
    works: "Works",
    why_choose: "Why choose",
    sub_heading_01: "The effortless School Management.",
    heading_02: "A Unified Technology Partner for All Your School's Needs",

    para_01:
      "Revolutionize the way your school operates with TeachWings, the all-in-one school management solution. Designed to cater to the needs of students, parents, teachers, and administrators, TeachWings simplifies communication, learning, and administrative tasks, making school operations more efficient, transparent, and secure.",
    heading_03: "About TeachWings",
    superAdmin: "Super Admin",
    admin: "Admin",
    receptionist: "Receptionist",
    librarian: "Librarian",
    classTeacher: "Class Teacher",
    teacher: "Teacher",
    student: "Student",
    parent: "Parent",
    heading_04: "About TeachWings",
    para_03:
      "TeachWings is built with the vision of simplifying school management and empowering all stakeholders students, parents, teachers, and administrators. Our mission is to provide a secure, intuitive platform that streamlines communication, enhances learning, and automates administrative tasks. With TeachWings, we’re helping schools across the world adopt technology that improves educational outcomes, reduces administrative burdens, and fosters a collaborative environment. Let’s fly with TeachWings and save time.",
    heading_05: "Key Features of TeachWings",

    card_heading_01: "Administrators",
    card_heading_02: "Teachers",
    card_heading_03: "Students",
    card_heading_04: "Parents",

    card_para_01:
      "Streamline admissions, manage users, schedules, fees,transportation, and generate insightful reports for efficient operations and informed decisions.",
    card_para_02:
      "Manage classes, track performance, grade, and engage effectively.",
    card_para_03:
      "Access grades, timetables, assignments, exams, and resources effortlessly.",
    card_para_04:
      "Stay updated on progress, attendance, fees, and communicate seamlessly.",

    keyFeatures: {
      list_01:
        "Comprehensive User Management: Manage teachers, students, staff and parents with full control over roles and permissions.",
      list_02: "New Admissions and academic session management",
      list_03:
        "Create & Update Timetables: Easily set up class schedules, exams, and school events.",
      list_04:
        "Fee & Financial Management: Monitor school finances, manage fee structures, and track payments efficiently.",
      list_05:
        "Transportation management: Transport management ensures safe, efficient routing, tracking, and scheduling of buses for student transportation while maintaining compliance and safety.",
      list_06:
        "Data-Driven Reports: Generate detailed reports and analytics on attendance, performance, finances, and more.",
      list_07:
        "Manage Classes & Assignments: Organize classes, assignments, and lesson plans all in one place.",
      list_08: "Attendance Management: Class attendance records and tracking.",
      list_09:
        "Monitor Student Progress: View and track individual student performance and provide timely feedback.",
      list_10:
        "Grade book & Report Cards: Enter grades quickly, generate report cards, and assess student performance.",
      list_11:
        "Communication Tools: Directly engage with students and parents via the built-in messaging system.",
      list_12:
        "Track Grades/marks & Report Cards: Get instant access to your grades/marks, assignments, and performance updates.",
      list_13:
        "View Timetable & Schedule: Never miss a class with your personalized timetable and upcoming events.",
      list_14:
        "Homework & Assignments: Easily view and manage your homework and assignments, with due dates and submission reminders.",
      list_15:
        "Exam Updates & Results: Stay up-to-date with exam schedules, and get results as soon as they are available.",
      list_16:
        "Learning Resources: Access digital study materials, lesson plans, and notes from teachers anytime, anywhere.",
      list_17:
        "Track Grades/marks & Report Cards: Get instant access to your grades/marks, assignments, and performance updates.",
      list_18:
        "View Timetable & Schedule: Never miss a class with your personalized timetable and upcoming events.",
      list_19:
        "Homework & Assignments: Easily view and manage your homework and assignments, with due dates and submission reminders.",
      list_20:
        "Exam Updates & Results: Stay up-to-date with exam schedules, and get results as soon as they are available.",
      list_21:
        "Learning Resources: Access digital study materials, lesson plans, and notes from teachers anytime, anywhere.",
    },

    heading_06: "How TeachWings Works",
    card_heading_05: "Sign up",
    card_heading_06: "Set Up Your Profile",
    card_heading_07: "Start Using the Features",
    card_heading_08: "Stay Connected",
    card_para_05: "Register your school and select a subscription.",
    card_para_06:
      "Personalize your dashboard and configure settings based on your role and preferences.",
    card_para_07:
      "Access all key features grades, assignments, communication tools, timetables, and more right away.",
    card_para_08:
      "Get real-time updates on grades, attendance, and school news. Communicate directly with teachers and parents, all within the app.",
    heading_07: "Why Choose TeachWings?",
    whyChoose: {
      list_01:
        "Streamlined School Operations: Manage everything from class schedules and attendance to grades and fees in a single, easy-to-use platform.",
      list_02:
        "Enhanced Communication: Stay informed with real-time notifications, direct messaging, and instant updates for all users.",
      list_03:
        "Time-Saving Automation: Automate tasks like grading, attendance tracking, and fee reminders, allowing you to focus on what truly matters—education.",
      list_04:
        "Secure & Private: Your data is safe with us. TeachWings adheres to the highest standards of data protection and privacy.",
      list_05:
        "Customizable for Your School: Tailor the platform to suit your school’s unique needs, with flexible features and settings.",
    },
    para_04: "The effortless School  Management.",
  },
  keyFeatures: {
    heading: {
      w1: "Key Features ",
      w2: "of TeachWings",
    },
    adminFeat: {
      h1: "Administrator",
    },
    teacherFeat: {
      h1: "Teachers",
    },
    studentFeat: {
      h1: "Students",
    },
    parentFeat: {
      h1: "Parents",
    },
  },
  contactUs: {
    heading_01: "Leave us a message or send an email to",
    name: "Name",
    email: "Email",
    contactNumber: "Contact number",
    message: "Message",
    cancel: "Cancel",
    submit: "Submit",
  },
  readMore: {},
  common: {
    getStarted: "Get Started",
    and: "and",
    registerNow: "Register Now",
    loginNow: "Login Now",
    knowMore: "Know More",
    learnMore: "Learn More",
  },

  footer: {
    availableOn: "Available on",
    contactEnquiry: "Contact / Enquiry",
    navigate: "Navigate",
    usefullLinks: "Useful links",
    footer_para:
      "Have questions or need help? Contact us for a demo or more information.",
    allRightsReserved: "All rights reserved.",
    playStore: "Play store",
    home: "Home",
    roles: "Roles",
    features: "Features",
    whyUs: "Why Us",
    contactUs: "Contact Us",
    appStore: "App store",
    register: "Register",
    login: " Login",
  },
  privacy: {
    h1: "Privacy Policy",
  },
};
